import {
  createSlice,
  PayloadAction,
} from '@reduxjs/toolkit';
import { MultiMediaResponse } from 'artifacts/dtos/multiMediaResponse';

const initialState: MultiMediaResponse[] = [];

export const organizationMediaSlice = createSlice({
  name: 'organizationMedia',
  initialState,
  reducers: {
    organizationMediaAction: (state, action: PayloadAction<MultiMediaResponse[]>) => action.payload,
  },
});

export const { organizationMediaAction } = organizationMediaSlice.actions;

export default organizationMediaSlice.reducer;
